import { createContext } from 'react';

const LoginContext = createContext();
export default LoginContext;



// WEBPACK FOOTER //
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/src/components/Login/loginContext.js